import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './styles.css';

function ensureTheme() {
  const saved = localStorage.getItem('pref_theme'); // 'dark' | 'light'
  const el = document.documentElement;
  el.setAttribute('data-theme', saved === 'light' ? 'light' : 'dark');
}
ensureTheme();

createRoot(document.getElementById('root')!).render(<App />);
